'use client';

export const AUCTION_UPDATE_INTERVAL = 1000;
export const BIDS_PER_PAGE = 20;
export const INITIAL_BIDS_COUNT = 10;
export const INFINITE_SCROLL_THRESHOLD = 100;
